import { DocumentServicesObject } from '@wix/document-services-types';
import { getCanvasOverlayContainer } from '../../../ui/canvasOverlay/canvasOverlayContainer';
import { IWorkspaceApiAdapter } from '../../utils/workspaceApiAdapter';
import { overlayStore } from './overlayStore';
import {
  siteDimensionsStore,
  updateSiteDimensions,
} from './siteDimensionsStore';
import { PlatformApiMethods } from '../../../types/platformApi';

export const init = (
  hostApi: PlatformApiMethods,
  documentServicesAPI: DocumentServicesObject,
  workspaceAPI: IWorkspaceApiAdapter,
  isResponsiveEditor: boolean,
): void => {
  documentServicesAPI.platform.registerToAppRemoved(
    (appDefinitionId: string) => {
      overlayStore.remove(appDefinitionId);
    },
  );

  documentServicesAPI.registerToSiteChanged(() =>
    updateSiteDimensions(hostApi, documentServicesAPI),
  );

  workspaceAPI.contributeStageComponent(() =>
    getCanvasOverlayContainer(
      overlayStore.register,
      siteDimensionsStore.register,
      isResponsiveEditor,
    ),
  );
};

export { overlayStore };
